import { USER_RESET_PASSWORD_REQUEST, USER_RESET_PASSWORD_SUCCESS, USER_RESET_PASSWORD_FAILURE } from '../constants/password.constants';

const initialState = {
    isResetPassword: false,
    hasResetPassword: false,
    error: null,
};

export const Reset_password_form = (state = initialState, action) => {
    switch (action.type) {
    case USER_RESET_PASSWORD_REQUEST:
        return {
            ...state,
            isResetPassword: true,
            hasResetPassword: false,
        };
    case USER_RESET_PASSWORD_SUCCESS:
        return {
            ...state,
            isResetPassword: false,
            hasResetPassword: true,
        };
    case USER_RESET_PASSWORD_FAILURE:
        return {
            ...state,
            isResetPassword: false,
            hasResetPassword: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/reset_password.reducers.js